function reverse(a) {
	a.reverse();
	return a;
}

module.exports = reverse;


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/reverse.js
 **/